<script setup lang="ts">
	import {msg} from "@/i18n/Message";
	import {ref, PropType} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import ProgressButton from "./ProgressButton.vue";
	import { useBaseStep } from './BaseStep';
	import { CrmInstallData, useCrmInstallData } from '../CrmInstallData';
	
	const emit = defineEmits(['nextStep', 'updateForm']);
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/language" }
	});
	const { errorMessage, isError, progress, sendForm } = useBaseStep(props,emit,validateForm);
	const { getData } = useCrmInstallData();
	
	function validateForm(): boolean {
		return true;
	}
	
	function changeLanguage(event): void {
		emit('updateForm', 'language', event.target.value);
		sendForm(props.form);
		getData(props.restApi+"/bundle?lang="+props.form.language)
		.then((data)=>{
			if (data) {
				window.bundle = new Map(Object.entries(data));
				window.location.reload();
				//console.log("Resources size:"+window.bundle.size);
				//console.log("Map value:"+window.bundle.get("profile.timezone"));
			}
		});
	}
</script>
<template>
	<div>
	<div class="formTitle">{{msg("install.welcome.selectLang")}}</div>
	<form>
		<table border="0" cellspacing="0" class="formTable">
			<tr>
				<td style="padding-bottom: 10px">
					<select :value="form.language" @input="changeLanguage($event)" tabindex="10">
					<option value="cs">{{msg("install.welcome.czech")}}</option>
					<option value="en">{{msg("install.welcome.english")}}</option>
				</select>
				</td>
			</tr>
			<tr>
				<td><error-msg :show="isError" :msg="errorMessage"/></td>
			</tr>
			<tr>
				<td style="padding-top:10px">				
					<progress-button @click="sendForm(form,'Selection')" :progress="progress"
						class="button" icon="page-next-16-full" tabindex="20">
						{{msg('install.butt.next')}}
					</progress-button>
				</td>
			</tr>
		</table>
	</form>
	</div>
</template>
